import { Lightning as lng, Registry } from '@lightningjs/sdk';
import { getDayInfoString, getTime } from '../../../Business/utility/DateFormatter';
import { Theme } from '../../../config/theme';

const _constants = {
  timeMarginLeft: 322,
  channelProgramsWidth: 1432,
  animationDurationSeconds: 0.5,
};

export class GuideTimeline extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Day: {
        x: 0,
        text: {
          ...Theme.Fonts.Guide.TimeLine,
          text: 'Today',
        },
      },
      TimeContainer: {
        clipping: true,
        x: _constants.timeMarginLeft,
        w: w => w - _constants.timeMarginLeft,
        h: h => h,
      },
    };
  }

  _init() {
    // Log.info('[GuideTimeline] _init', this);
  }

  updateTime(start) {
    this.tag('Day').text.text = getDayInfoString(start, true, this.backend);
    this.tag('TimeContainer').childList.clear();
    this.tag('TimeContainer').childList.a(this._getTimeRow(start));
  }

  moveRight(start) {
    // this.moveRightAnimated(start);
    this.moveRightStatic(start);
  }
  moveRightStatic(start) {
    // no Animation just change the data
    this.tag('Day').text.text = getDayInfoString(start, true, this.backend);
    this.changeTime(start);
  }
  moveRightAnimated(start) {
    this.tag('Day').text.text = getDayInfoString(start, true, this.backend);
    this.tag('TimeContainer').childList.a({
      ...this._getTimeRow(start),
      x: _constants.channelProgramsWidth,
    });
    this.tag('TimeContainer').children[0].setSmooth('x', -_constants.channelProgramsWidth, {
      duration: _constants.animationDurationSeconds,
    });
    this.tag('TimeContainer').children[1].setSmooth('x', 0, { duration: _constants.animationDurationSeconds });
    Registry.setTimeout(() => {
      this.tag('TimeContainer').childList.remove(this.tag('TimeContainer').childList.first);
    }, _constants.animationDurationSeconds * 1000);
  }

  moveLeft(start) {
    // this.moveLeftAnimated(start);
    this.moveLeftStatic(start);
  }
  moveLeftStatic(start) {
    // no Animation just change the data
    this.tag('Day').text.text = getDayInfoString(start, true, this.backend);
    this.changeTime(start);
  }
  moveLeftAnimated(start) {
    this.tag('Day').text.text = getDayInfoString(start, true, this.backend);
    this.tag('TimeContainer').childList.addAt(
      {
        ...this._getTimeRow(start),
        x: -_constants.channelProgramsWidth,
      },
      0
    );
    this.tag('TimeContainer').children[1].setSmooth('x', _constants.channelProgramsWidth, {
      duration: _constants.animationDurationSeconds,
    });
    this.tag('TimeContainer').children[0].setSmooth('x', 0, { duration: _constants.animationDurationSeconds });
    Registry.setTimeout(() => {
      this.tag('TimeContainer').childList.remove(this.tag('TimeContainer').childList.last);
    }, _constants.animationDurationSeconds * 1000);
  }

  changeTime(start) {
    const startCopy = new Date(start);
    const timeContainer = this.tag('TimeContainer');
    if (timeContainer.children.length > 0) {
      const timeRow = timeContainer.childList.first.childList.first;
      timeRow.childList.getAt(0).text.text = getTime(startCopy);
      timeRow.childList.getAt(1).text.text = getTime(new Date(startCopy.setMinutes(30)));
      timeRow.childList.getAt(2).text.text = getTime(new Date(startCopy.setMinutes(60)));
      timeRow.childList.getAt(3).text.text = getTime(new Date(startCopy.setMinutes(30)));
    } else {
      this.updateTime(start);
    }
  }

  /**
   * get a lng component row that contains 4 time stamps from date + 2 hours
   * @param {Date} start
   * @return {Element}
   * @private
   */
  _getTimeRow(start) {
    const startCopy = new Date(start);
    const spacing = _constants.channelProgramsWidth / 4;
    return {
      TimeRow: {
        Spot1: {
          x: 0,
          text: {
            ...Theme.Fonts.Guide.TimeLine,
            text: getTime(startCopy),
          },
        },
        Spot2: {
          x: spacing,
          text: {
            ...Theme.Fonts.Guide.TimeLine,
            text: getTime(new Date(startCopy.setMinutes(30))),
          },
        },
        Spot3: {
          x: spacing * 2,
          text: {
            ...Theme.Fonts.Guide.TimeLine,
            text: getTime(new Date(startCopy.setMinutes(60))),
          },
        },
        Spot4: {
          x: spacing * 3,
          text: {
            ...Theme.Fonts.Guide.TimeLine,
            text: getTime(new Date(startCopy.setMinutes(30))),
          },
        },
      },
    };
  }
}
